// const URL_REGEX = /(https?:\/\/[^\s<>"'()]+(?:\.[^\s<>"'()]+)*|[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+\.[a-zA-Z]{2,}(?:\/[^\s<>"'()]*)?)/gi;

// const TRAILING_PUNCTUATION = /[.,!?;:'")]+$/;

// export function linkifyText(text) {
//     if (!text) return [];

//     const tokens = [];
//     let lastIndex = 0;
//     let match;

//     URL_REGEX.lastIndex = 0;

//     while ((match = URL_REGEX.exec(text)) !== null) {
//         const rawUrl = match[0];
//         let cleanUrl = rawUrl;
//         let suffix = "";

//         const punctMatch = rawUrl.match(TRAILING_PUNCTUATION);
//         if (punctMatch) {
//             cleanUrl = rawUrl.slice(0, -punctMatch[0].length);
//             suffix = punctMatch[0];
//         }

//         if (cleanUrl.includes(".") || cleanUrl.startsWith("http")) {
//             if (match.index > lastIndex) {
//                 tokens.push({ type: "text", value: text.slice(lastIndex, match.index) });
//             }
//             tokens.push({ type: "url", value: cleanUrl });
//             if (suffix) {
//                 tokens.push({ type: "text", value: suffix });
//             }
//             lastIndex = match.index + rawUrl.length;
//         }
//     }

//     if (lastIndex < text.length) {
//         tokens.push({ type: "text", value: text.slice(lastIndex) });
//     }

//     return tokens.length > 0 ? tokens : [{ type: "text", value: text }];
// }

// export function getUrlHref(url) {
//     return url.startsWith("http://") || url.startsWith("https://")
//         ? url
//         : `https://${url}`;
// }


//==============================


const URL_REGEX =
    /\b((?:(?:https?|ftp):\/\/)?(?:www\.)?(?:localhost|\d{1,3}(?:\.\d{1,3}){3}|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,63}))(?::\d{1,5})?(?:\/[^\s<>"']*)?)/gi;

export function linkifyText(text) {
    if (!text) {
        return [{ type: "text", value: "" }];
    }

    const tokens = [];
    let lastIndex = 0;

    URL_REGEX.lastIndex = 0;

    let match;

    while ((match = URL_REGEX.exec(text)) !== null) {
        const raw = match[0];

        let url = raw;
        let trailing = "";

        // Remove invalid ending punctuation
        while (/[),.!?;:\]}]/.test(url[url.length - 1]) && url.length > 0) {
            trailing = url.slice(-1) + trailing;
            url = url.slice(0, -1);
        }

        // Ignore invalid tiny matches
        if (url.length < 3) continue;

        // Previous text
        if (match.index > lastIndex) {
            tokens.push({
                type: "text",
                value: text.slice(lastIndex, match.index),
            });
        }

        tokens.push({
            type: "url",
            value: url,
        });

        // Add removed punctuation back
        if (trailing) {
            tokens.push({
                type: "text",
                value: trailing,
            });
        }

        lastIndex = match.index + raw.length;
    }

    // Remaining text
    if (lastIndex < text.length) {
        tokens.push({
            type: "text",
            value: text.slice(lastIndex),
        });
    }

    return tokens.length ? tokens : [{ type: "text", value: text }];
}

export function getUrlHref(url) {
    const lower = url.toLowerCase();

    // Already valid protocol
    if (
        lower.startsWith("http://") ||
        lower.startsWith("https://") ||
        lower.startsWith("ftp://")
    ) {
        return url;
    }

    // localhost or ip
    if (lower.startsWith("localhost") || /^\d{1,3}(?:\.\d{1,3}){3}/.test(lower)) {
        return `http://${url}`;
    }

    // default
    return `https://${url}`;
}

export function sanitizeUrl(url) {
    try {
        const safeUrl = getUrlHref(url);

        const parsed = new URL(safeUrl);

        if (
            parsed.protocol === "http:" ||
            parsed.protocol === "https:" ||
            parsed.protocol === "ftp:"
        ) {
            return parsed.href;
        }

        return "#";
    } catch {
        return "#";
    }
}